import type { LabeledValuePayload } from '@Application/Users/UserStatuses/Actions/userStatusesFetched';

export type ContactRolesFetchedPayload = LabeledValuePayload[];

export type ContactRolesFetchedAction = {
	type: 'CONTACT_ROLES_FETCHED';
	payload: ContactRolesFetchedPayload;
};

export default (payload: ContactRolesFetchedPayload): ContactRolesFetchedAction => ({
	type: 'CONTACT_ROLES_FETCHED',
	payload,
});
